<template>
  <div class="pointer data-table-th-line data-table-list-member">
    <el-dropdown trigger="click" placement="bottom-start" v-if="type === 'tag'">
      <div>
        <div v-if="tag_select.id == 'all'">
          タグ<font-awesome-icon icon="caret-down" style="margin-left:5px" />
        </div>
        <div class="list-detail-side-member" v-else>
          <div>{{ tag_select.tag_name }}</div>
          <font-awesome-icon icon="caret-down" style="margin-left:5px" />
        </div>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="selectTag(all_tag)" :class="tag_select.id == 'all' ? 'assign' : ''">全てのタグ</el-dropdown-item>
        <el-dropdown-item
          style="font-size:12px;"
          v-for="tag in tag_list"
          :key="tag.id"
          @click.native="selectTag(tag)"
          :class="tag_select.id == tag.id ? 'assign' : ''"
        >
            {{ tag.tag_name }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "memberBrandSelect",
  props: ["type", "tag_list"],
  data() {
    return {
      all_tag: {
        id: "all",
      },
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    activate() {
      return this.$store.state.activate;
    },
    tag_select() {
      return this.$store.state.tag_select;
    },
  },
  methods: {
    selectTag(tag) {
      this.$emit("selectTag", tag);
    },
  },
};
</script>

<style></style>
